var map = {
	"./check.svg": 2995,
	"./dollar.svg": 2996,
	"./file-symlink.svg": 2997,
	"./filter.svg": 2998,
	"./leaf.svg": 2999,
	"./life.svg": 3000,
	"./load.svg": 3001,
	"./people.svg": 3002,
	"./shield.svg": 3003,
	"./umberella.svg": 3004
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2994;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/bfile_result ^\.\/.*\.svg$
// module id = 2994
// module chunks = 0